module.exports = __webpack_public_path__ + "img/51.b968f2bb.jpg";